export default __webpack_public_path__ + "static/media/fi_sex.1fa1e861.png";